import * as Yup from "yup";

const validation = Yup.object({});

export default validation;
